<div class="app-container">
  <mdb-sidenav-layout>
    <!-- Sidenav -->

    <mdb-sidenav #sidenav="mdbSidenav" id="app-sidenav" [mode]="sidenavMode()" [width]="320"
      [backdrop]="sidenavMode() === 'over'" [focusTrap]="sidenavMode() === 'over' && isSidenavOpen()"
      [hidden]="!isAuthenticated() || !isSidenavOpen()" [attr.aria-hidden]="!isAuthenticated() || !isSidenavOpen()"
      (sidenavShown)="setSidenavOpen(true)" (sidenavHidden)="setSidenavOpen(false)">
      <div class="sidenav-container">
        <div class="menu-header">
          @if(!isLoginPage()){
          <button class="close-menu" #closeMenuButton type="button" (click)="closeSidenav()"
            aria-label="Close navigation menu" [attr.aria-hidden]="isLoginPage()">
            <i class="fa-solid fa-xmark material-icon-fa menu-icon" [attr.aria-hidden]="true"></i>
          </button>
          }


          <div class="logo-container">
            <a routerLink="/dashboard" aria-labelledby="logo-title">
              <svg role="img" aria-labelledby="logo-title" class="responsive-logo-header"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 900" xml:space="preserve">
                <title id="logo-title">Direct Access to Self-Help Logo</title>
                <path class="logo-light"
                  d="M261.9 307c-.3-4.2-.9-8.4-.8-12.6 0-8.1.8-16.2.9-24.3v-37.5l1-79.8 1-70.8q.6-19.3 1.5-39.2l29.7 19.9 77 52.4 74.6 50.8 72.7 49.3 74.1 50.7q48.8 33 97.4 66.3c1.7 1.2 2.9 4.4 2.9 6.6q.2 43.5.1 87c0 48.1-.2 96.3.2 144.4 0 6.7-2.4 10.1-7.7 12.7q-1.4.9-3.4 1.6l-3.5-2.7-50.5-33.2-135.8-89.4q-2.6-1.4-5.4-2.4-13.1-9-26.4-17.7l-43-28.3c-1-1.2-1.4-2.4-2.2-3l-52.4-34.4q-47.5-31.6-95-62.8-3.4-2-7-3.5" />
                <path class="logo-dark"
                  d="M487.6 457q3 .7 5.7 2.2L629 548.6l50.5 33.2q1.5 1 3.2 2.8-17.6 10.9-35.4 21.5L584 644.5 520.5 683l-63.4 38.4-68.4 41.4-63 38.3q-29.8 18-59.6 36.3-1.4.8-4.2 2c-.3-2-.9-3.7-.9-5.4l-.1-231c0-4.1 2.4-5 5-6.6l40.2-26 85.7-54.4 29-18.4v41l33.4-41.1 21.1-25.4z" />
                <path class="logo-darker"
                  d="M262 307.5q3.5 1 6.8 3l95.1 63 52.4 34.3q1 1 1.8 3v42.7c0 3-.8 4.6-3.3 6.4q-32.1 21.7-64.1 43.6L286 547l-21.8 15-.9-.2-.3-.4q-.5-.3-.7-.7l-.3-1V307.6" />
              </svg>
            </a>

          </div>
        </div>
        @if(!isLoginPage())
        {
        <ul class="sidenav-menu">
          <mdb-sidenav-item>
            <a class="sidenav-link menu-item" routerLink="/dashboard">
              <i class="fa-solid fa-house material-icon-fa" aria-hidden="true"></i>
              Home
            </a>
          </mdb-sidenav-item>
          <!--<mdb-sidenav-item>
            <a class="sidenav-link menu-item" href="#">
              <i class="fa-solid fa-file-signature material-icon-fa"  aria-hidden="true"></i>
              Forms and Kits
            </a>
          </mdb-sidenav-item>
          <mdb-sidenav-item>
            <a class="sidenav-link menu-item" tabindex="0" mdbRipple role="button"
              [attr.aria-expanded]="!selfHelpCategory.collapsed" aria-controls="Self Help Information">
              <i class="fa-solid fa-handshake-angle material-icon-fa"  aria-hidden="true"></i><span>Self Help</span></a>
            <ul class="sidenav-collapse" mdbCollapse id="selfHelpCategory" #selfHelpCategory="mdbCollapse">
              <li class="sidenav-item ">
                <a class="sidenav-link menu-item-secondary" tabindex="0" mdbRipple>Child Support</a>
              </li>
              <li class="sidenav-item ">
                <a class="sidenav-link menu-item-secondary" tabindex="0" mdbRipple>Family Law</a>
              </li>
              <li class="sidenav-item ">
                <a class="sidenav-link menu-item-secondary" tabindex="0" mdbRipple>Guardianship</a>
              </li>
              <li class="sidenav-item ">
                <a class="sidenav-link menu-item-secondary" tabindex="0" mdbRipple>Self-Help Landlord /
                  Tenant</a>
              </li>
              <li class="sidenav-item ">
                <a class="sidenav-link menu-item-secondary" tabindex="0" mdbRipple>Self-Help Small
                  Claims</a>
              </li>
            </ul>
          </mdb-sidenav-item>
          <mdb-sidenav-item>
            <a class="sidenav-link menu-item" href="#">
              <i class="fa-solid fa-briefcase material-icon-fa"  aria-hidden="true"></i>
              My Cases
            </a>
          </mdb-sidenav-item>
          <mdb-sidenav-item>
            <a class="sidenav-link menu-item" href="#">
              <i class="fa-solid fa-calendar-check material-icon-fa"  aria-hidden="true"></i>
              My Appointments
            </a>
          </mdb-sidenav-item>
          
          <mdb-sidenav-item>
            <a class="sidenav-link menu-item" aria-label="Search Workshops" routerLink="/search-workshops">
              <i class="fa-solid fa-magnifying-glass material-icon-fa"  aria-hidden="true"></i>
              Search Workshops
            </a>
          </mdb-sidenav-item>-->
          <!-- 
          <mdb-sidenav-item>
            <a class="sidenav-link menu-item" href="#">
              <i class="fa-solid fa-envelope material-icon-fa"  aria-hidden="true"></i><span>Inbox / Notifications</span>
            </a>
          </mdb-sidenav-item>-->
          <mdb-sidenav-item>
            <a class="sidenav-link menu-item" aria-label="View Service Request History"
              routerLink="/service-request-history">
              <i class="fa-solid fa-headset material-icon-fa" aria-hidden="true"></i>
              Service Requests
            </a>
          </mdb-sidenav-item>
          <mdb-sidenav-item>
            <a class="sidenav-link menu-item" aria-label="My Workshops" routerLink="/my-workshops">
              <i class="fa-solid fa-chalkboard-user material-icon-fa"  aria-hidden="true"></i>
              My Workshops
            </a>
          </mdb-sidenav-item>
          <mdb-sidenav-item>
            <a class="sidenav-link menu-item" aria-label="My Account" routerLink="/my-account">
              <i class="fa-solid fa-circle-user material-icon-fa" aria-hidden="true"></i><span>My Account</span>
            </a>
          </mdb-sidenav-item>
        </ul>
        }


        <app-gradientsegmentbar class="mb-0"></app-gradientsegmentbar>
        @if (isAuthenticated() && !isLoginPage()) {
        <div class="d-grid gap-2 text-center mx-4 mb-4">
          <button (click)="onLogoutClick();" class="btn btn-lg btn-primary" mdbRipple>
            LOGOUT
          </button>
        </div>
        }

      </div>
    </mdb-sidenav>
    <!-- Top  Navbar Content -->
    <mdb-sidenav-content [attr.inert]="sidenavMode() === 'over' && isSidenavOpen() ? '' : null">
      <nav class="navbar" [class.d-md-block]="isLoginPage()" [class.d-none]="isLoginPage()">
        <div class="container-fluid">
          <!-- Left side: Logo and Title -->
          <div class="navbar-brand d-flex align-items-center gap-3 flex-grow-1"
            [class.fade-out]="isSidenavOpen() && sidenavMode() === 'over'">
            <!-- Right side: User info (only when authenticated) -->
            @if (isAuthenticated()) {
            <!-- Navbar Toggler  d-md-none -->
            <button #menuToggle class="navbar-toggler" type="button" (click)="toggleSidenav()"
              aria-label="Toggle navigation" aria-controls="app-sidenav" [attr.aria-expanded]="isSidenavOpen()">
              <div class="menu-toggle-content">
                <i class="fa-solid fa-bars material-icon-fa menu-icon" aria-hidden="true"></i>
              </div>
            </button>
            }
            <a [routerLink]="isAuthenticated() ? '/dashboard' : '/'" aria-labelledby="navbar-logo-title">
              <svg class="responsive-logo-header" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 900" role="img"
                aria-labelledby="navbar-logo-title" xml:space="preserve">
                <title id="navbar-logo-title">Superior Court of San Bernardino Logo</title>
                <path class="logo-light"
                  d="M261.9 307c-.3-4.2-.9-8.4-.8-12.6 0-8.1.8-16.2.9-24.3v-37.5l1-79.8 1-70.8q.6-19.3 1.5-39.2l29.7 19.9 77 52.4 74.6 50.8 72.7 49.3 74.1 50.7q48.8 33 97.4 66.3c1.7 1.2 2.9 4.4 2.9 6.6q.2 43.5.1 87c0 48.1-.2 96.3.2 144.4 0 6.7-2.4 10.1-7.7 12.7q-1.4.9-3.4 1.6l-3.5-2.7-50.5-33.2-135.8-89.4q-2.6-1.4-5.4-2.4-13.1-9-26.4-17.7l-43-28.3c-1-1.2-1.4-2.4-2.2-3l-52.4-34.4q-47.5-31.6-95-62.8-3.4-2-7-3.5" />
                <path class="logo-dark"
                  d="M487.6 457q3 .7 5.7 2.2L629 548.6l50.5 33.2q1.5 1 3.2 2.8-17.6 10.9-35.4 21.5L584 644.5 520.5 683l-63.4 38.4-68.4 41.4-63 38.3q-29.8 18-59.6 36.3-1.4.8-4.2 2c-.3-2-.9-3.7-.9-5.4l-.1-231c0-4.1 2.4-5 5-6.6l40.2-26 85.7-54.4 29-18.4v41l33.4-41.1 21.1-25.4z" />
                <path class="logo-darker"
                  d="M262 307.5q3.5 1 6.8 3l95.1 63 52.4 34.3q1 1 1.8 3v42.7c0 3-.8 4.6-3.3 6.4q-32.1 21.7-64.1 43.6L286 547l-21.8 15-.9-.2-.3-.4q-.5-.3-.7-.7l-.3-1V307.6" />
              </svg>
            </a>


            <div class="header-title d-none d-md-block">
              <h1 class="mb-0">SUPERIOR COURT OF SAN BERNARDINO</h1>
              <h2 class="mb-0">DIRECT ACCESS TO SELF-HELP</h2>
            </div>
          </div>
          <!-- Right side: User info (only when authenticated) -->
          @if (isAuthenticated()) {
          <div class="d-none d-md-flex align-items-center gap-2 gap-md-3 me-md-3">
            <!--<button type="button"
              class="position-relative d-inline-flex align-items-center bg-transparent border-0 p-0">
              <i class="fa-solid fa-envelope material-icon-fa profile-icon" aria-hidden="true"></i>
              <span
                class="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle">
                <span class="visually-hidden">New alerts</span>
              </span>
            </button>-->
            <a aria-label="My Account" routerLink="/my-account"><i
                class="fa-solid fa-circle-user material-icon-fa profile-icon" aria-hidden="true"></i></a>
            <a class="d-none user-name d-lg-flex" routerLink="/my-account">{{ userName() }}</a>
          </div>
          }
        </div>
      </nav>

      <main class="d-flex flex-column flex-grow-1" [class.login-main]="isLoginPage()">
        <router-outlet></router-outlet>
      </main>
      <app-footer></app-footer>

    </mdb-sidenav-content>

  </mdb-sidenav-layout>

</div>